import React from "react";
import { Drawer } from "../../../../../../../../components/drawer/drawer/drawer.component";
import { DrawerHeader } from "../../../../../../../../components/drawer/drawer-header/drawer-header.component";
import { FlyerDetailPageDetailSideMenu } from "../../features/flyer-detail-page-side-menu/components/flyer-detail-page-detail-side-menu/flyer-detail-page-detail-side-menu.component";
import Grid from "@material-ui/core/Grid";
import { FlyerDetailPageDrawerProps } from "./flyer-detail-page-drawer.props";
import { FlyerDetailPageDrawerSubHeader } from "../flyer-detail-page-drawer-sub-header/flyer-detail-page-drawer-sub-header.component";
import { FlyerDetailPageForm } from "../flyer-detail-page-form/flyer-detail-page-form.component";
import { getFlyerDrawerHeader } from "../../types/flyer-detail-page-drawer-header/flyer-detail-page-drawer-header.functions";
import { withShowIf } from "../../../../../../../../components/with-show-if/with-show-If.component";

export const FlyerDetailPageDrawer = withShowIf((props: FlyerDetailPageDrawerProps) => (
  <Drawer open={props.editType !== "none"} onExpandChange={props.onExpandChange} expandable>
    <DrawerHeader header={getFlyerDrawerHeader(props.editType)} onClose={props.onClose} />
    <Grid container>
      <Grid item xs={10} sm={10} md={10} lg={10}>
        <FlyerDetailPageDrawerSubHeader pageLabel={props.pageLabel} editType={props.editType} />
        <FlyerDetailPageForm
          flyerEndDatePassed={props.flyerEndDatePassed}
          pageId={props.pageId}
          pagePositionId={props.editPositionId}
          type={props.editType}
          selectedLanguage={props.selectedLanguage}
          permissions={props.permissions}
          onChange={props.onPageUpdate}
          onSelectLanguage={props.onSelectLanguage}
        />
      </Grid>
      <Grid item xs={2} sm={2} md={2} lg={2}>
        <FlyerDetailPageDetailSideMenu
          editType={props.editType}
          hasPageDetails={props.hasPageDetails}
          onClick={props.onChangeEditType}
        />
      </Grid>
    </Grid>
  </Drawer>
));
